export const ADDRESS_SHIPPING_FIELDS = [
  'id',
  'address1',
  'address2',
  'city',
  'state',
  'zipcode',
  'country',
];
